// @flow
import advertiseActionKeys from './advertiseActionKeys';
import * as service from './advertiseService';

export const
  advertiseRequest = (
    activityLocation?: string,
    description?: string,
    categorySegmentData?: Object,
  ): {|
  meta: {|
    activityLocation: void | string,
    categorySegmentData: any | void,
    description: void | string,
  |},
  payload: {|promise: any|},
  type: any,
|} => ({
    type: advertiseActionKeys.ADVERTISE_REQUEST,
    payload: {
      promise: service.advertiseRequest(),
    },
    meta: {
      activityLocation,
      description,
      categorySegmentData,
    },
  });

export const closeAdvertiseAlert = (): {|type: any|} => ({
  type: advertiseActionKeys.ADVERTISE_REQUEST_RESET,
});

export const
  advertiseRequestByCategory =
  (serviceProviderId: string, categoryGroupId: number, contactCountDisplayed: number):
  {|meta: {|categoryGroupId: number|}, payload: {|promise: any|}, type: any|} => ({
    type: advertiseActionKeys.ADVERTISE_CATEGORY_REQUEST,
    payload: {
      promise: service.advertiseRequestByCategory(
        serviceProviderId,
        categoryGroupId,
        contactCountDisplayed,
      ),
    },
    meta: {
      categoryGroupId,
    },
  });

export const contactCountByTopCategory =
  (serviceProviderId: string, startTime: string, endTime: string):
  {|payload: {|promise: any|}, type: any|} => ({
    type: advertiseActionKeys.ADVERTISE_CONTACT_COUNT,
    payload: { promise: service.contactCountByTopCategory(serviceProviderId, startTime, endTime) },
  });



// WEBPACK FOOTER //
// ./src/app/common/advertise/advertiseActions.js